(() => {
  if (customElements.get('al-learning')) return;
  class Learning extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.items = [...this.querySelectorAll('[data-learn-item]')];
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = matchMedia('(max-width: 899px)');
      const signal = this.controller.signal;
      this.schedule = () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.draw(); });
      };
      addEventListener('scroll', this.schedule, { passive: true, signal });
      addEventListener('resize', this.schedule, { passive: true, signal });
      this.reduced.addEventListener('change', this.schedule, { signal });
      this.mobile.addEventListener('change', this.schedule, { signal });
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, { signal });
      this.addEventListener('focusout', () => { this.focused = false; this.schedule(); }, { signal });
      if (window.Shopify?.designMode) {
        document.addEventListener('shopify:block:select', event => {
          if (this.contains(event.target)) {
            this.selected = event.target;
            this.selected.scrollIntoView({ block: 'center', behavior: 'instant' });
            this.schedule();
          }
        }, { signal });
        document.addEventListener('shopify:block:deselect', () => { this.selected = null; this.schedule(); }, { signal });
      }
      this.schedule();
    }
    reset(item) {
      item.style.removeProperty('transform');
      item.style.removeProperty('opacity');
      item.style.removeProperty('clip-path');
    }
    draw() {
      const height = innerHeight;
      const section = this.getBoundingClientRect();
      const staticMode = this.reduced.matches || (this.mobile.matches && this.dataset.mobile !== 'true') || this.focused;
      if (!staticMode && (section.bottom < 0 || section.top > height * 1.1)) return;
      const distance = Number(this.dataset.distance || 24) * (this.mobile.matches ? .6 : 1);
      const runway = height * Number(this.dataset.range || 30) / 100;
      for (const item of this.items) {
        const effect = item.dataset.effect && item.dataset.effect !== 'inherit' ? item.dataset.effect : this.dataset.effect;
        if (staticMode || effect === 'none' || item === this.selected) { this.reset(item); continue; }
        const transform = item.style.transform;
        item.style.transform = 'none';
        const rect = item.getBoundingClientRect();
        item.style.transform = transform;
        const progress = Math.max(0, Math.min(1, (height * .96 - rect.top) / runway));
        const eased = 1 - Math.pow(1 - progress, 3);
        const exit = this.dataset.exit === 'true' ? Math.max(0, Math.min(1, rect.bottom / (height * .18))) : 1;
        item.style.opacity = String((.15 + .85 * eased) * exit);
        item.style.clipPath = effect === 'mask' ? `inset(0 0 ${(1 - eased) * 100}% 0)` : 'none';
        item.style.transform = effect === 'rise' ? `translateY(${(1 - eased) * distance}px)` : effect === 'left' ? `translateX(${(1 - eased) * distance}px)` : effect === 'scale' ? `scale(${.96 + .04 * eased})` : 'none';
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.items?.forEach(item => this.reset(item));
    }
  }
  customElements.define('al-learning', Learning);
})();
